




import { Vue, Component } from 'vue-property-decorator'
import { StatusesMap } from '@/models/StatusesMap'
import { Action, Getter, Mutation } from 'vuex-class'
import { Status } from '@/api/models/Status'
import AccountService from '@/api/services/AccountService'
import { RootStateMutations } from '@/store/mutations'
import Account from '@/api/models/Account'
import AccountOption from '@/api/models/AccountOption'
import AccountOptions from '@/models/AccountOptions'
import { getDefaultAccountOptions } from '@/components/helper'

@Component
export default class Statuses extends Vue {
    $refs: {
        updateError: Element;
    }

    protected accountOptions: AccountOptions = getDefaultAccountOptions()
    protected currentStatusMapping: Array<StatusesMap> = []
    protected errorCurrentStatusesMap = ''
    protected error = ''

    @Action('loadCdekStatuses')
    protected loadCdekStatuses!: () => Promise<void>

    @Action('loadSystemStatuses')
    protected loadSystemStatuses!: () => Promise<void>

    @Mutation(RootStateMutations.setLoading)
    protected setLoading: (load: boolean) => void

    @Getter('currentAccount')
    protected currentAccount: Account

    @Getter('getSystemStatusesList')
    protected systemStatuses: Array<Status>

    @Getter('getCdekStatusesList')
    protected cdekStatuses: Array<Status>

    @Action('loadSystemProductStatuses')
    protected loadSystemProductStatuses!: () => Promise<void>

    @Action('loadSystemPaymentStatuses')
    protected loadSystemPaymentStatuses!: (accountId: number) => Promise<void>

    @Getter('getSystemProductStatusesList')
    protected systemProductStatuses: Array<Status>

    @Getter('getSystemPaymentStatusesList')
    protected systemPaymentStatuses: Array<Status>

    protected accountService = new AccountService()

    async created (): Promise<void> {
        await this.loadData()
    }

    async loadData(): Promise<void> {
        this.setLoading(true)
        try {
            await this.loadCdekStatuses()
            await this.loadSystemStatuses()
            await this.loadStatusMapping()
            if (this.currentAccount?.id) {
                this.accountOptions = await this.accountService.getAccountOptions(this.currentAccount.id)
            }
            await this.loadSystemProductStatuses()
            if (this.currentAccount?.id) {
                await this.loadSystemPaymentStatuses(this.currentAccount.id)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.statuses.error.getStatuses').toString()
        } finally {
            this.setLoading(false)
        }
    }

    async updateStatusesMappings(statusesMap: StatusesMap): Promise<void> {
        this.clearError()
        this.setLoading(true)

        try {
            if (this.currentAccount?.id) {
                await this.accountService.updateStatuses(this.currentAccount.id, statusesMap)
            }
        } catch (err) {
            this.scroll()

            this.error = err.response?.data?.message ?? this.$t('settings.statuses.error.saveStatusMap').toString()
        } finally {
            this.setLoading(false)
        }
    }

    async loadStatusMapping(): Promise<void> {
        try {
            if (this.currentAccount?.id) {
                this.currentStatusMapping = await this.accountService.getStatusesMappings(this.currentAccount.id)
            }
        } catch (err) {
            this.errorCurrentStatusesMap =
                err.response?.data?.message ?? this.$t('settings.statuses.error.getMapStatuses').toString()
        }
    }

    async updateAccountOptions(accountOption: AccountOption): Promise<void> {
        this.clearError()
        this.setLoading(true)

        try {
            if (this.currentAccount?.id) {
                await this.accountService.updateAccountOptions(this.currentAccount.id, accountOption)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.internal.error').toString()

            this.scroll()
        } finally {
            this.setLoading(false)
        }
    }

    scroll (): void {
        this.$refs.updateError.scrollIntoView({ behavior: 'smooth' })
    }

    clearError() {
        this.error = ''
    }
}
